module.exports = __webpack_public_path__ + "media/country_flags/aq-e8dac5d0.png";